import * as React from 'react'
import AppRouter from './router/AppRouter';
import './App.css';
import NotificationState from './components/toast/NotificationState';

function App() {
  return (
    <div>
      <NotificationState>
        <AppRouter />
      </NotificationState>
    </div>
  );
}

export default App;
